module.exports = __webpack_public_path__ + "static/media/pb-contacts.a6730020.png";